import { IS_DEBUG } from '@common/constants/is-debug.constant';
import { IIdObject } from '@common/interfaces/id-object.interface';
import { IProductCatalogItem } from '../pack-house-generated-api';
import { createCachedItemPriceDto, ICachedItemPriceDto } from './cached-item-price.dto';

export interface ICachedProductCatalogItemDto extends IIdObject {
    item:
        | ({
              prices: ICachedItemPriceDto[];
          } & Omit<IProductCatalogItem, 'prices'>)
        | undefined;
    price: number;
}

export const createCachedProductCatalogItemDto = (it: IProductCatalogItem): ICachedProductCatalogItemDto => {
    const prices = IS_DEBUG
        ? it.prices?.map((pr) => createCachedItemPriceDto(pr)) || []
        : it.prices?.filter((it) => it.period_unit == 'week').map((pr) => createCachedItemPriceDto(pr)) || [];
    const price = prices[0] ? prices[0].price : 0;
    return {
        id: it.id || '',
        price: price || 0,
        item: {
            ...it,
            prices,
        },
    };
};
